import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa"; // Import the icons

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-6">
  {/* <div className="container mx-auto px-4 md:flex">
  <div className="flex-1 text-center mb-6">
    <p className="text-left font-bold text-xl">Siddhi Ganapathi Developers</p>
    <p className="italic text-xl">
      "Building dreams, one flat at a time — creating open spaces for everyone."
    </p>
  </div>

  <div className="flex-1 text-center mb-6">
    <p className="text-left font-bold text-xl">Address:</p>
    <p className="text-[16px]">
      4th Floor, MKR Enclave, Kammayathopu, Pantakaluva road, NTR Marg,
      Kanuru Vijayawada, Andhra Pradesh
    </p>
  </div>

  <div className="flex-1">
    <p className="text-left font-bold text-xl">Social Links:</p>
    <div className="flex justify-center space-x-6">
      <a
        href="https://www.facebook.com/OpenFlatRealEstate"
        target="_blank"
        rel="noopener noreferrer"
        className="text-gray-400 hover:text-white"
      >
        <FaFacebookF size={24} /> 
      </a>
      <a
        href="https://twitter.com/OpenFlatRE"
        target="_blank"
        rel="noopener noreferrer"
        className="text-gray-400 hover:text-white"
      >
        <FaTwitter size={24} /> 
      </a>
      <a
        href="https://www.instagram.com/openflatrealestate"
        target="_blank"
        rel="noopener noreferrer"
        className="text-gray-400 hover:text-white"
      >
        <FaInstagram size={24} /> 
      </a>
      <a
        href="https://www.linkedin.com/company/openflatrealestate"
        target="_blank"
        rel="noopener noreferrer"
        className="text-gray-400 hover:text-white"
      >
        <FaLinkedinIn size={24} /> 
      </a>
    </div>
  </div>
</div> */}

      <div className="text-center mt-6">
        <a href="https://oakyaitservices.com/">
        <h1>
            Copyright © 2025 Designed by Oakya IT Services. All Rights Reserved.
          </h1>
        </a>
         
        </div>
    </footer>
  );
};

export default Footer;
